import type { Feature, FeatureStatus } from "../tracking/Tracking";
import { extractFeature } from "../tracking/FeatureTracking";
import { determineStatus, trackedFacetValue, trackedFacetValueOld, trackedFilterMethod } from "./FilterTracking";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

const AUTOMATIC: NonNullable<Feature["labels"]>["san_FilterMethod"][number] = "automatic";

function parseLabels(elem: HTMLElement): Record<string, unknown> {
  return JSON.parse(elem.dataset.tsFeatureLabels || "{}") as Record<string, unknown>;
}

function isAutomaticValue(elem: HTMLElement): boolean {
  const method = parseLabels(elem).san_FilterMethod;
  return Array.isArray(method) && method.includes(AUTOMATIC);
}

/**
 *
 *
 *
 */
function changedValueLabels(input: HTMLInputElement): Feature["labels"] {
  const labels = parseLabels(input);

  const type = input.type || input.getAttribute("type");
  if (type === "text") {
    labels.san_FacetValue = [trackedFacetValueOld(input.value)];
  } else if (type === "radio" && input.value.includes(",")) {
    labels.san_FacetValue = [trackedFacetValue(input.value)];
  }

  const filterMethod = trackedFilterMethod(input);
  if (filterMethod !== undefined) {
    labels.san_FilterMethod = [filterMethod];
  } else {
    delete labels.san_FilterMethod;
  }

  return labels as Feature["labels"];
}

/**
 *
 *
 *
 *
 */
export function assembleChangeFeatures(elem: HTMLInputElement): Feature[] {
  const status: FeatureStatus = determineStatus(elem);
  const overview = document.querySelector<HTMLElement>('[data-ts-feature-name="Filter-Overview"]');
  const filter = elem.closest<HTMLElement>('[data-ts-feature-name="Filter"]');
  const facet = elem.closest<HTMLElement>('[data-ts-feature-name="Facet"]');

  const features: Feature[] = [];
  if (overview) features.push(extractFeature(overview));
  if (filter) features.push({ ...extractFeature(filter), status });
  if (facet) features.push({ ...extractFeature(facet), status });

  document.querySelectorAll<HTMLInputElement>('[data-ts-feature-name="Facet-Value"]').forEach((value) => {
    if (value.id === elem.id) {
      features.push({ ...extractFeature(value), status, labels: changedValueLabels(value) });
    } else if (isAutomaticValue(value)) {
      features.push(extractFeature(value));
    }
  });

  return features;
}
